import { render, staticRenderFns } from "./ConcernsCard.vue?vue&type=template&id=fb3f7518&scoped=true&"
import script from "./ConcernsCard.vue?vue&type=script&lang=js&"
export * from "./ConcernsCard.vue?vue&type=script&lang=js&"
import style0 from "./ConcernsCard.vue?vue&type=style&index=0&id=fb3f7518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3f7518",
  null
  
)

export default component.exports